var sound_control_default = {
  "root": "I5en9",
  "sliderContainer": "OxIXy"
};
export {
  sound_control_default as default
};
//# sourceMappingURL=sound-control-scss.js.map
